import PropTypes from 'prop-types';
import React from "react";
import { Routes, Route } from 'react-router-dom';
import { connect } from "react-redux";

// Import Routes all
import { userRoutes, authRoutes, administrationRoutes, ordenRoutes, exportacionRoutes } from "./routes/allRoutes";
import Pages404 from "./pages/Utility/pages-404";

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware";
import EnhancedAuthMiddleware from "./routes/middleware/EnhancedAuthMiddleware";

// layouts Format
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"


// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// }

// init firebase backend
// initFirebaseBackend(firebaseConfig)

const App = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route>
          {authRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <NonAuthLayout>
                  {route.component}
                </NonAuthLayout>
              }
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {userRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <EnhancedAuthMiddleware>
                  {route.component}
                </EnhancedAuthMiddleware>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {administrationRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <EnhancedAuthMiddleware>
                  {route.component}
                </EnhancedAuthMiddleware>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {ordenRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <EnhancedAuthMiddleware>
                  {route.component}
                </EnhancedAuthMiddleware>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        <Route>
          {exportacionRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <EnhancedAuthMiddleware>
                  {route.component}
                </EnhancedAuthMiddleware>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>
        
        <Route path="*" element={<Pages404 />} />
      </Routes>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
